export default "__VITE_ASSET__ce65a9c6__"